<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <loading
        :active="loader"
        :can-cancel="false"
        :is-full-page="true"
    ></loading>
      <b-row>
        <!--<b-col cols="1" align="right" class="d-flex justify-content-start mt-1">
          <b-button variant="outline-light" style="color:#00a4aa;border: none" @click="regresar()"><b-icon icon="arrow-left-circle" ></b-icon></b-button>
        </b-col>-->

<!--        <b-button @click="abrirModal(1)">abrir 1 modal</b-button>
        <b-button @click="abrirModal(2)">abrir 2 modal</b-button>
        <b-button @click="abrirModal(3)">abrir 3 modal</b-button>
        <b-button @click="abrirModal(4)">abrir 4 modal</b-button>-->

        <b-col cols="11">
          <b-container fluid class="divSubtitulo m-1 mb-3">
            <p class="textoSubtitulo">{{subtitulo}}</p>
          </b-container>
        </b-col>
      </b-row>

      <p class="textSubtitulo ml-1">{{ nombrePaciente }} - ID PTI: {{ idPti }} - {{ fechaAceptacion }}</p>

      <b-row>
          <div class="ml-3" v-for="(opcion) in datosTabla" :key="opcion.idOpcion">
            <b-button size="sm" variant="outline-info" class="mr-1 estilo-iconos" style="color:var(--color-dentalia-v2); border-radius: 6px; font-weight: 600;" :disabled="!opcion.opcionAceptada" :style="opcion.opcionAceptada?'text-decoration: none;   box-shadow: 0px 10px 10px -6px black;':''">{{opcion.nombreOpcion}}
              <span v-if="opcion.opcionAceptada">(Opcion ACEPTADA)</span>
            </b-button>
          </div>

      </b-row>
    <div class="centrar-elementos mt-5">
      <b-button-group size="sm" style="border-radius: 60px; background-color: #f6f5fc;">
        {{datosTabla.fases}}
        <div v-for="(fase) in fases" :key="fase.fase">
          <b-button variant="outline-light" size="sm" @click="obtenerFaseSeleccionada(fase.fase)" :class="opcionPtiSeleccionadaSubtitulo === fase.fase ? 'boton-switch-active' : 'boton-switch'">
            Fase {{fase.fase}} del Tratamiento
            <div v-if="opcionPtiSeleccionadaSubtitulo === fase.fase" class="linea"></div>
          </b-button>
        </div>
      </b-button-group>
    </div>

<!--      === Diseño anterior botones ===
      <b-row class="centrar-elementos mt-5">
        {{datosTabla.fases}}
        <div  v-for="(fase) in fases" :key="fase.fase">
          <b-button  size="sm" variant="outline-info" class="estilo-iconos" style="color:var(--color-dentalia-v2); border-radius: 20px; font-weight: 600;" @click="obtenerFaseSeleccionada(fase.fase)" :style="opcionPtiSeleccionadaSubtitulo === fase.fase?'text-decoration: underline;   box-shadow: 0px 10px 10px -6px black;':'text-decoration: none'">
            Fase {{fase.fase}} del Tratamiento
          </b-button>
        </div>
      </b-row>-->
      <div>
        <b-row class="ml-1 mr-1 mt-4">
          <b-col cols="2">
          </b-col>
          <b-col cols="10" v-show="!mostrarPtiActual" >
            <p style="color: var(--color-icono); font-weight: 600" class="text-left">{{subtitulo}}</p>
          </b-col>

          <b-col cols="10" v-show="mostrarPtiActual">
            <b-row>
              <b-col>
                <p style="color: var(--color-icono); font-weight: 600" class="text-left">Pti Actual (Tx programados)</p>
              </b-col>
              <b-col class="text-right">
                <div v-if="!modoEdicion">
                  <b-button
                      style="box-shadow: rgb(0 0 0 / 25%) 0px 3px 4px 0px"
                      variant="light"
                      class="rounded-circle mr-2 paddingbotones"
                      v-b-popover.hover.topleft="'Historial de cambios pos-aceptación'"
                      v-b-toggle.sidebar-historial
                  >
                    <em class="historial_svg sm"></em>
                  </b-button>
                  <b-button
                      style="box-shadow: rgb(0 0 0 / 25%) 0px 3px 4px 0px"
                      variant="light"
                      class="rounded-circle ml-2 paddingbotones"
                      v-b-popover.hover.topleft="'Entrar al modo edición'"
                      @click="entrarModoEdicionPtiActual"
                      v-if="puedeEditar"
                  >
                    <em class="edit_pencil_svg sm"></em>
                  </b-button>
                </div>

                <div v-if="modoEdicion">
                  <b-button
                      v-if="$localStorageService.can('BT_agregar_Tx_pti')"
                      id="popover-boton-agregar"
                      style="box-shadow: rgb(0 0 0 / 25%) 0px 3px 4px 0px"
                      variant="light"
                      class="rounded-circle ml-2 paddingbotones"
                      v-b-popover.hover.top="'Agregar nuevo diente'"
                      @click="agregarTratamiento()"
                  >
                    <em class="mas_azul_svg sm"></em>
                  </b-button>
                  <b-button
                      id="popover-boton-info"
                      style="box-shadow: rgb(0 0 0 / 25%) 0px 3px 4px 0px"
                      variant="light"
                      class="rounded-circle ml-2 paddingbotones"
                  >
                    <em class="i_info_svg sm"></em>
                  </b-button>
                  <b-popover target="popover-boton-info" triggers="hover" placement="topleft">
                    <p style="color: var(--color-icono); font-weight: 600" class="text-left">Acciones realizadas</p>
                    <table>
                      <tbody>
                      <tr>
                        <td><b-icon icon="circle-fill" aria-hidden="true" font-scale="2" style="color: #cdf5c6;"></b-icon></td>
                        <td><p class="mt-2 mb-2" style="font-size: .80em">Tratamiento agregado a tx. aceptado</p></td>
                      </tr>
                      <tr>
                        <td><b-icon icon="circle-fill" aria-hidden="true" font-scale="2" style="color: #ffbcc0"></b-icon></td>
                        <td><p class="mt-2 mb-2" style="font-size: .80em">Tratamiento eliminado</p></td>
                      </tr>
                      <tr>
                        <td><b-icon icon="circle-fill" aria-hidden="true" font-scale="2" style="color: #ffc794"></b-icon></td>
                        <td><p class="mt-2 mb-2" style="font-size: .80em">Tratamiento rechazado</p></td>
                      </tr>
                      <tr>
                        <td></td>
                        <td><p class="mt-2 mb-2" style="color: #8a8a8a; font-size: .80em" >Tratamiento eliminado</p></td>
                      </tr>
                      </tbody>
                    </table>
                  </b-popover>
                </div>
              </b-col>
            </b-row>
            <hr>
          </b-col>


          <b-col cols="col-2    col-10 col-sm-2   col-10 col-xs-10    col-10 col-md-2   mt-1 mb-4 " class="contenedorTablaSinColor">
            <p class="bold-blue text-left mt-2" style="font-size: 2vh;">Versiones del PTI</p>
            <hr>
            <div v-if="$localStorageService.can('BT_Detalle_PTI_diagnostico')" class="card mt-4 mb-4 opciones-versionespti">
              <div>
                <p class="titulo-versionespti m-1"><strong>Diagnóstico</strong></p>
                <p class="subtitulo-versionespti"  @click="seleccionoSubtituloVersionPti(1, )"  :class=" opcionPtiSeleccionada === 1? 'subtitulo-seleccionado': ''" :style="opcionPtiSeleccionada === 1 ?'text-decoration: underline':'text-decoration: none'">PTI Original
                </p>
              </div>
            </div>
            <div v-if="$localStorageService.can('BT_Detalle_PTI_presentacion')" class="card mt-4 mb-4 opciones-versionespti justify-content-center">
              <div>
                <p class="titulo-versionespti m-1"><strong>Presentación</strong></p>
                <p class="subtitulo-versionespti"  @click="seleccionoSubtituloVersionPti(2)" :class=" opcionPtiSeleccionada === 2? 'subtitulo-seleccionado': ''" :style="opcionPtiSeleccionada === 2 ?'text-decoration: underline':'text-decoration: none'">PTI Presentado</p>
                <p class="subtitulo-versionespti" @click="seleccionoSubtituloVersionPti(3)" :class=" opcionPtiSeleccionada === 3? 'subtitulo-seleccionado': ''" :style="opcionPtiSeleccionada === 3 ?'text-decoration: underline':'text-decoration: none'">PTI Aceptado</p>
              </div>
            </div>

            <div v-if="$localStorageService.can('BT_Detalle_PTI_actual_editable')" class="card mt-4 mb-4 opciones-versionespti">
              <div>
                <p class="titulo-versionespti m-1"><strong>PTI Actual</strong></p>
                <p class="subtitulo-versionespti"  @click="seleccionoSubtituloVersionPti(4)" :class=" opcionPtiSeleccionada === 4? 'subtitulo-seleccionado': ''" :style="opcionPtiSeleccionada === 4 ?'text-decoration: underline':'text-decoration: none'">PTI Actual</p>
              </div>
            </div>

          </b-col>
          <b-col cols="10" v-show="!mostrarPtiActual">
            <PTIOriginal :datosTabla="datosTablaTratamientos" :loader="loaderSubtitulo" :opcionPtiSeleccionada="opcionPtiSeleccionada"/>
          </b-col>

          <b-col cols="10" v-show="mostrarPtiActual">
            <PTIActual :datosTabla="datosTablaTratamientos" :datosTablaNuevos="datosTablaNuevosTratamientos" :loader="loaderSubtitulo" :modoEdicion="modoEdicion"
             :opcionesEstatus="opcionesEstatus" ref="ptiActual" :idPti="idPti" :opcionAceptada="1"  :etapasFiltro="etapasFiltro" :listaDientes="listaDientes" :arrayDiente="arrayDiente"
             :arrayTratamiento="arrayTratamiento" :arrayTratamientoFiltro="arrayTratamientoFiltro" :arrayPadecimiento= "arrayPadecimiento" :arrayPadecimientoFiltro="arrayPadecimientoFiltro"

            />
          </b-col>

        </b-row>
      </div>
    <div class="m-5 text-center" v-if="modoEdicion">
      <b-button variant="info"
                class="mr-2"
                @click="modalObservaciones()"
                :disabled="revisarSiExisteDatoEditable()">Guardar ****</b-button>
      <b-button @click="salirModoEdicionPtiActual"
                class="ml-2"
                :disabled="loader">Cancelar</b-button>
    </div>

    <div>
      <b-sidebar
          id="sidebar-historial"
          no-header
          right
          shadow
          width="400px"
      >
        <template #default="{ hide }">
          <div style="background-color: white">
          <div class="text-right">
            <b-button @click="hide" variant="light" size="sm">
              <em class="equis_svg icon-boton sm"></em>
            </b-button>
          </div>
          <HistorialCambios :idPti="idPti" :opcionesEstatus="opcionesEstatus"/>
          </div>
        </template>
      </b-sidebar>
    </div>
    <b-modal title=""
      size="lg"
      v-model="modalObservacionesDoctores"
      hide-footer
      hide-header
    >
     <div fluid>
      <b-row class="ml-3 mb-2">
        <h3><em class="tabla_diente_svg icon-boton sm"></em></h3>
        <p style="color: var(--color-dentalia); font-size: 20px; font-weight: bold; padding-top: 5px; padding-left: 8px;">Información sobre cambios y nuevos tratamientos</p>
      </b-row>
      <b-row class="mr-1 ml-1">
        <b-col class="text-left">
          <p class="pb-0 mb-1" style="font-size: 14px;">Doctor(es) que solicitaron</p>
          <b-card style="border-color: var(--color-dentalia-v2); border-radius: 15px;">
            <b-form-input
                v-model="listaDoctoresFiltro.nombre"
                placeholder="Ingresa un nombre"
                type="text"
                v-on:keypress="esLetra($event)"
                @keyup.prevent="buscarDoctoresEnFiltros($event)"
            ></b-form-input>

            <b-dropdown-divider></b-dropdown-divider>

            <validation-provider
              :name="'validacioncausa' + options.check"
              :rules="{ required: true }"
              v-slot="causaSlot"
            >
            <b-form-checkbox-group stacked style="overflow: auto;  max-height: 200px" v-model="selected"  @input="marcarDoctor()">
              <template v-for="(d,i) in options">
                <b-form-checkbox :key="d+i" v-if="d.visible == true" :value="d.value">
                  <div class="row ml-1">
                    <p style="font-size: 14px;">{{ d.nombre }} </p>
                    <p style="font-size: 12px; color: #8a8a8a;">({{ d.especialidad }})</p>
                  </div>
                </b-form-checkbox>
              </template>
            </b-form-checkbox-group>
            <validacion
              :texto="causaSlot.errors[0] ? causaSlot.errors[0] : ''"
            ></validacion>
            </validation-provider>
          </b-card>
        </b-col>
        <b-col class="text-left">
          Observaciones
          <validation-provider
            :name="'validacioncausa' + observaciones"
            :rules="{ required: true }"
            v-slot="observacionesSlot"
          >
            <b-form-textarea
              id="textarea"
              v-model="observaciones"
              placeholder="Escriba sus observaciones"
              max-rows="10"
              style="border-radius: 10px; height: 50%;"
            ></b-form-textarea>
            <validacion
              :texto="observacionesSlot.errors[0] ? observacionesSlot.errors[0] : ''"
            ></validacion>
          </validation-provider>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col style="text-align: right;"><b-button @click="continuar()" pill variant="primary" :disabled="ids.length == 0 || observaciones == ''">Continuar</b-button></b-col>
        <b-col style="text-align: left;"><b-button @click="cerrarModal()" pill>Cancelar</b-button></b-col>
      </b-row>
    </div>

    </b-modal>
  </div>
</template>

<script>
import PTIOriginal from "@/views/historialPTI/PTIOriginal.vue";
import PTIActual from "./PTIActual";
import HistorialCambios from "./historialCambios";
import {ValidationProvider} from 'vee-validate'

export default {

  name: "DetallePTIVisible",
  components:{
    HistorialCambios,
    PTIActual,
    PTIOriginal,
    ValidationProvider
  },

  data:()=>{
    return{
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      mostrarListaDiagnostico:true,
      mostrarListaPresentados:true,
      mostrarListaPtiActual:true,
      fases:[],
      opcionPtiSeleccionada: 1,
      datosTabla:[],
      datosTablaTratamientos : [],
      datosTablaNuevosTratamientos: [],
      loader: false,
      loaderSubtitulo: false,
      opcionPtiSeleccionadaSubtitulo: 0,
      mostrarPtiActual: false,
      modoEdicion: false,
      subtitulo:"",
      opcionesEstatus: [],
      idSolicitud: null,
      listaTxModificados: [],
      tipoDiente: null,
      arrayTratamiento: [],
      arrayTratamientoFiltro: [],
      arrayPadecimiento: [],
      arrayPadecimientoFiltro: [],
      arrayDiente: [],
      listaDientes: [],
      etapasFiltro: [],
      listaDoctores: [],
      listaDoctoresFiltro: [],
      doctores: [],
      modalObservacionesDoctores: false,
      observaciones: "",
      options: [],
      selected: [],
      ids: [],
      puedeEditar: false,
    }
  },
  props: {
    nombrePaciente: String,
    idPti: Number,
    fechaAceptacion: String,
    idPaciente: Number,
    opcionAceptadaHistorial: Number
  },
  async created() {
    this.debug = this.$localStorageService.getDebug();

    await this.obtenerDiagnostico();
    this.obtenerFaseSeleccionada(1);
    this.obtenerEstatusPti();
  },
  
  methods: {
    async seleccionoSubtituloVersionPti(subtitulo) {
      if(this.modoEdicion) {
        this.salirModoEdicionPtiActual();
      }else {
        this.opcionPtiSeleccionada = subtitulo;
        this.opcionPtiSeleccionadaSubtitulo = 1;
        this.datosTablaTratamientos = [];
        if (subtitulo === 1) {
          this.mostrarPtiActual = false
          await this.obtenerDiagnostico();
          this.obtenerFaseSeleccionada(1);
          this.subtitulo = "PTI ORIGINAL";
        }
        if (subtitulo === 2) {
          this.mostrarPtiActual = false
          await this.obtenerPresentado();
          this.obtenerFaseSeleccionada(1);
          this.subtitulo = "PTI PRESENTACIÓN";
        }
        if (subtitulo === 3) {
          this.mostrarPtiActual = false
          await this.obtenerAceptados();
          this.obtenerFaseSeleccionada(1);
          this.subtitulo = "PTI ACEPTACIÓN";
        }

        if (subtitulo === 4) {
          this.mostrarPtiActual = true
          await this.obtenerPtiActual();
          this.subtitulo = "PTI ACTUAL (TX PROGRAMADOS)";
        }
      }
    },
    async obtenerDiagnostico(){
      this.datosTabla = [];
      this.loader = true;
      const params = {
        idPti: this.idPti
      }
      this.$http.post(this.$api + 'pti/visible/obtener/tratamientos/diagnostico', params)
      .then(respuesta => {
            if (respuesta.data.data) {
              respuesta.data.data.forEach(it => {
                this.datosTabla.push(it);
                if (it.opcionAceptada){
                 this.fases = it.fases;
                }
              })
            }

          }
      ).finally(() => {
            this.loader = false;
          }
      )
    },
    async obtenerPresentado(){
      this.datosTabla = [];
      this.loader = true;
      const params = {
        idPti: this.idPti
      }
      this.$http.post(this.$api + 'pti/visible/obtener/tratamientos/presentados', params)
      .then(respuesta => {
            if (respuesta.data.data) {
              respuesta.data.data.forEach(it => {
                this.datosTabla.push(it);
                if (it.opcionAceptada){
                  this.fases = it.fases;
                }
              })
            }

          }
      ).finally(() => {
            this.loader = false;
          }
      )
    },
    abrirModal(noModal) {
      // * Modal 1 es cuando sale de MODO EDICION CUANDO TIENE CAMBIOS
      if (noModal === 1) {
        let tituloAlerta = '<span class="mt-4" style="font-weight:600; font-size: 20px; color: var(--color-gris)">¿Está seguro de cerrar el modo edición?</span></br></br>'
        let parrafo = '<span >Si continúa se perderán los cambios,</br>' +
            '¿desea continuar?</span>'
        this.$swal.fire({
          width: '550px',
          icon: 'warning',
          html: tituloAlerta + parrafo,
          showCloseButton: false,
          showCancelButton: true,
          confirmButtonText: 'Sí',
          confirmButtonColor: '#eeba6d',
          cancelButtonText: 'No',
          cancelButtonColor: '#595959',
          customClass: {
            confirmButton: 'mr-5 rounded-pill',
            cancelButton: 'ml-5 rounded-pill'
          },
        }).then((result) => {
          if (result.isConfirmed) {
            this.modoEdicion = false;
            this.$refs.ptiActual.salirModoEdicion();
            this.obtenerFaseSeleccionada(this.opcionPtiSeleccionadaSubtitulo);
            this.datosTablaNuevosTratamientos = [];
          }
        })
      }

      // * Modal 2 es cuando GUARDA LOS CAMBIOS
      if (noModal === 2) {
        let tituloAlerta = '<span class="mt-4" style="font-weight:600; font-size: 20px; color: var(--color-gris)">Se realizarán los siguientes cambios ¿Desea </br> continuar?</span></br></br>'

        /**
         * EMPIEZA LA CONSTRUCCION DE LA TABLA
         */

        let listaCambiosReplica = [];

        this.datosTablaTratamientos.forEach(tx=>{
          tx.tratamientos.forEach(t=>{
            if(t.cambiosTratamiento != null || t.cambiosTratamiento != undefined){
              t.cambiosTratamiento.forEach(c => {
                if (c.idTratamiento !== null){
                  c.fase = t.fase;
                  listaCambiosReplica.push(c)
                }
              })
            }

            let i = this.listaTxModificados.findIndex(i => i.idPtiTratamiento === t.idPtiTratamiento && t.editado === false);
            if(i > -1) {
              this.listaTxModificados.splice(i, 1);
            }
            if(t.editado){
              let index = this.listaTxModificados.findIndex(i => i.idPtiTratamiento === t.idPtiTratamiento);
              if(index < 0) {
                this.listaTxModificados.push(t);
              }
            }
          });
        });


        let tabla =
            '<div class="contenedorTablaSinColor p-2"><table style="width: 100%; font-size: 14px;">' +
            '  <tr style="border-bottom: 1px solid #ccc;">' +
            '    <th>Fase</th>' +
            '    <th>Tratamiento</th>' +
            '    <th>Origen del tratamiento</th>' +
            '    <th>Cambia a</th>' +
            '    <th>Se enviará a UP</th>' +
            '  </tr>';

        this.listaTxModificados.forEach(l => {

          let colorLetra = '';
          let estatusTexto = this.opcionesEstatus.find(op => op.idEstatusPtiTratamiento === l.idEstatus).descripcion;

          if (l.idEstatus === 4) {
            colorLetra = '#d46718'
          } else if (l.idEstatus === 2) {
            colorLetra = '#2a9317';
          } else if (l.idEstatus === 5) {
            colorLetra = '#df0404';
          }

          tabla += `<tr>
                      <td><div style="padding: 5px;">${l.fase}</td>
                      <td><div style="padding: 5px;">${l.tratamiento}</td>
                      <td style="color: ${colorLetra}">PTI</td>
                      <td style="color: ${colorLetra}">${estatusTexto}</td>
                      <td style="color: ${colorLetra}">${l.idEstatus === 2 ? 'Si':''}</td>
                    </tr>`;
        })

        listaCambiosReplica.forEach(l => {

          tabla += `<tr>
                      <td><div style="padding: 5px;">${l.fase}</td>
                      <td><div style="padding: 5px;">${l.tratamiento}</td>
                      <td style="color: #d46718">PTI</td>
                      <td style="color: #d46718">Cambio de tratamiento</td>
                      <td style="color: #2a9317">Si</td>
                    </tr>`;
        });

        this.datosTablaNuevosTratamientos.forEach(nt => {
          let colorLetra = '';
          nt.tratamientos.forEach(t => {
            t.fase = this.opcionPtiSeleccionadaSubtitulo;
            if (t.idEstatus === 4) {
              colorLetra = '#d46718'
            } else if (t.idEstatus === 2) {
              colorLetra = '#2a9317';
            } else if (t.idEstatus === 5) {
              colorLetra = '#df0404';
            }

            tabla += `<tr>
                        <td><div style="padding: 5px;">${t.fase}</td>
                        <td><div style="padding: 5px;">${t.tratamiento}</td>
                        <td style="color: ${colorLetra}">NUEVO</td>
                        <td style="color: ${colorLetra}"></td>
                        <td style="color: ${colorLetra}">${t.idEstatus === 2 ? 'Si':''}</td>
                      </tr>`;
          });
        });

        tabla += '</table></div>'; //AQUI FINALIZA LA CONSTRUCCION DE LA TABLA
        this.$swal.fire({
          width: '750px',
          icon: 'warning',
          html: tituloAlerta + tabla,
          showCloseButton: false,
          showCancelButton: true,
          confirmButtonText: 'Sí',
          confirmButtonColor: '#eeba6d',
          cancelButtonText: 'No',
          cancelButtonColor: '#595959',
          customClass: {
            confirmButton: 'mr-5 rounded-pill',
            cancelButton: 'ml-5 rounded-pill'
          },
        }).then((result) => {
          if (result.isConfirmed) {
            this.loader = true;

            let objMandatorio = {
              idPti: this.idPti,
              idPaciente: this.idPaciente,
              idClinica: this.$localStorageService.getIdClinica(),
              trtEstatus: this.listaTxModificados,
              empleados: this.ids,
              observaciones: this.observaciones,
              trtCambiosR: listaCambiosReplica,
              trtNuevos: this.datosTablaNuevosTratamientos,
              opcion: this.opcionAceptadaHistorial
            }
            this.$http.post(this.$api + 'pti/visible/guardarIniciarEdicion/ptiActual', objMandatorio).then(respuesta => {
                  if (respuesta.data.data) {
                    if (this.listaTxModificados.some(tx => tx.idEstatus === 3) || (this.datosTablaNuevosTratamientos.length > 0) || (listaCambiosReplica != undefined && listaCambiosReplica.length > 0)) {
                      this.idSolicitud = respuesta.data.data
                      this.abrirModal(4)
                      this.modoEdicion = false;
                      this.datosTablaNuevosTratamientos = [];
                      this.ids = [];
                      this.observaciones = '';
                    //  this.$refs.ptiActual.salirModoEdicion();
                    } else {
                      this.idSolicitud = respuesta.data.data
                      this.abrirModal(3)
                      this.modoEdicion = false;
                      this.modalObservacionesDoctores = false;
                    //  this.$refs.ptiActual.salirModoEdicion();
                    }
                  }
                }
            ).catch((error) => {
              console.error("error guardar",error)
              this.loader = false;
              this.$swal.fire({
                icon: "error",
                title: "Aviso",
                text: "Ocurrió un error al realizar la operación",
              });
            }).finally(async () => {
              if (!this.listaTxModificados.some(i => i.idEstatus === 2) && this.listaTxModificados.some(i => i.idEstatus === 4)) {
                this.listaTxModificados = [];
                this.datosTablaTratamientos = [];
                this.obtenerFaseSeleccionada(this.opcionPtiSeleccionadaSubtitulo);
              }
              await this.obtenerPtiActual();
            })
          }
        })
      }

      // * Modal 3 cuando NO HAY NUEVOS TX PROGRAMADOS
      if (noModal === 3) {
        this.$swal.fire({
          icon: 'success',
          html: '<span class="mt-4" style="font-weight:600; font-size: 19px; color: var(--color-gris)">Edición de tratamientos guardada exitosamente</span>',
          showCloseButton: false,
          confirmButtonText: 'cerrar',
          confirmButtonColor: '#595959',
          customClass: {
            confirmButton: 'rounded-pill',
          },
          preConfirm: () => {
            let index = this.listaTxModificados.findIndex(i => i.idEstatus === 2);
              if(index >= 0) {
              this.$router.push({
                name: "resumenClinicoSeguimientoVisible",
                params: {
                  idPti: this.idPti,
                  idSolicitud: this.idSolicitud,
                  opcion: this.opcionAceptadaHistorial,
                },
              });
            }else{
              this.modoEdicion = false;
              this.$refs.ptiActual.salirModoEdicion();
              this.obtenerPtiActual();
            }
          }
        })
      }

      // * Modal 3 cuando SI HAY NUEVOS TX PROGRAMADOS
      if (noModal === 4) {
        let tituloAlerta = '<span class="mt-4" style="font-weight:600; font-size: 19px; color: var(--color-gris)">Edición de tratamientos guardada exitosamente</span></br></br>'
        let parrafo = '<span >Ahora se presentarán los tratamientos que se enviaron a la Unidad de Presentación</span>'

        this.$swal.fire({
          width: '620px',
          icon: 'success',
          html: tituloAlerta + parrafo,
          showCloseButton: false,
          confirmButtonText: 'cerrar',
          confirmButtonColor: '#595959',
          customClass: {
            confirmButton: 'rounded-pill',
          },
          preConfirm: () => {
            this.$router.push({
              name: "resumenClinicoSeguimientoVisible",
              params: {
                idPti: this.idPti,
                idSolicitud: this.idSolicitud,
                opcion: this.opcionAceptadaHistorial,
              },
            });
          }
        })
      }
      // * Modal 4 cuando HAY NUEVOS TX PROGRAMADOS
    },
    async obtenerAceptados(){
      this.datosTabla = [];
      this.loader = true;
      const params = {
        idPti: this.idPti
      }
      this.$http.post(this.$api + 'pti/visible/obtener/tratamientos/aceptados', params)
      .then(respuesta => {
            if (respuesta.data.data) {
              respuesta.data.data.forEach(it => {
                this.datosTabla.push(it);
                if (it.opcionAceptada){
                  this.fases = it.fases;
                  this.opcionAceptada = it.opcionAceptada;
                }
              })
            }

          }
      ).finally(() => {
            this.loader = false;
          }
      )
    },
    modalObservaciones(){
      let dt = false;
      let tr = false;
      this.datosTablaTratamientos.forEach(tx=>{
        tx.tratamientos.forEach(t=>{
          if(t.cambiosTratamiento != null){
            if(t.editado || (t.cambiosTratamiento.length > 0 && t.cambiosTratamiento[0].idTratamiento != null)){
              dt = true;
            }
            if(t.cambiosTratamiento.length > 0 && t.cambiosTratamiento[0].idTratamiento != null){
              tr = true;
            }
          }
        });
      });
      let j = false;
      let dtn = false;
      if(this.datosTablaNuevosTratamientos.length > 0){
        this.datosTablaNuevosTratamientos.forEach(nt => {
          nt.tratamientos.forEach(t => {
            if(t.idTratamiento != null && nt.idEtapa != null && nt.idPadecimiento != null && nt.idDiente != null && t.idEtapa != null){
              j = true;
            }else{
              j = false;
            }
          });
        });
        if(j){
          dtn = true;
        }else{
          dtn = false;
        }
      }
      if(dt == true && tr == false && dtn == false){
        this.abrirModal(2);
      }else{
        this.modalObservacionesDoctores = true;
      }
    },
    continuar(){
      this.abrirModal(2);
    },
    cerrarModal(){
      this.modalObservacionesDoctores = false;
    },
    traerDoctores(){
      this.loader = true;
      const params = {
        idClinica:this.$localStorageService.getIdClinica()
      }
      this.$http.post(this.$api + "colaboradores/obtenerEmpleadosEspecialidad", params
      ).then((response) => {
        if (response.status === 200) {
          this.listaDoctores = response.data.data.map((it) => {
            return {
              id: it.idEmpleado,
              nombre:  it.nombreEmpleado + " (" + this.obtenerEspecialidadesDoctor(it) + ")",
              nombreDoctor: it.nombreEmpleado,
              especialidad: this.obtenerEspecialidadesDoctor(it),
              visible: false,
              check: false,
            };
          }).filter((v, i, a) => a.findIndex((t) => t.id === v.id) === i);
          this.listaDoctoresFiltro = this.listaDoctores;
        }
      })
      .catch((error) => {
        this.loadingDoctoresClinica = false;
        console.error(error);
      })
      .finally(() => {
        this.loadingDoctoresClinica = false;
        this.llenarOpciones();
        this.loader = false;
      });
    },
    obtenerEspecialidadesDoctor(doctor) {
      if ( doctor.especialidades.length > 0) {
        var esp = "";
        doctor.especialidades.forEach(f => {
          esp += f + ", "
        })
        return esp;
      } else {
        return "-";
      }
    },
    buscarDoctoresEnFiltros() {
      this.options.forEach(o => {
        if(o.nombre.toUpperCase().includes(this.listaDoctoresFiltro.nombre.toUpperCase())){
          o.visible = true;
        }else{
          o.visible = false;
        }
      });
    },
    filtroDoctores(busqueda){
      let seach = busqueda
      this.listaDoctoresFiltro = this.listaDoctores.filter(em => {
        return em.descripcion.toLowerCase().includes(seach.toLowerCase())}
      )
    },
    esLetra(e) {
      let char = String.fromCharCode(e.keyCode);
      if (/^[A-Za-zÁÉÍÓÚáéíóúñÑ\s]+$/.test(char)) return true;
      else e.preventDefault();
    },
    marcarDoctor(){
      this.ids = [];
      this.selected.forEach(s => {
        this.ids.push(s);
      });
      this.listaDoctoresFiltro.forEach(ldf => {
        if(this.ids.includes(ldf.id)){
          ldf.check = true;
        }else{
          ldf.check = false;
        }
      });
    },
    llenarOpciones(){
      this.listaDoctoresFiltro.forEach(df => {
        this.options.push({text: df.nombre, value: df.id, numeroEmpleado: df.numeroEmpleado, nombre: df.nombreDoctor, especialidad: df.especialidad, visible: true})
      });
    },
    obtenerFaseSeleccionada(faseSeleccionada){
     if(this.modoEdicion) {
       this.datosTablaTratamientos.forEach(tx => {
         tx.tratamientos.forEach(t => {
           let i = this.listaTxModificados.findIndex(i => i.idPtiTratamiento === t.idPtiTratamiento && t.editado === false);
           if (i > -1) {
             this.listaTxModificados.splice(i, 1);
           }
           if (t.editado) {
             let index = this.listaTxModificados.findIndex(i => i.idPtiTratamiento === t.idPtiTratamiento);
             if (index < 0) {
               this.listaTxModificados.push(t);
             }
           }
         });
       });
     }
      this.opcionPtiSeleccionadaSubtitulo =faseSeleccionada;
        this.loaderSubtitulo = true;
        this.datosTablaTratamientos = [];
        setTimeout(()=>{
          this.datosTabla.forEach(op=>{
            if(op.opcionAceptada){
              if (this.mostrarPtiActual) {
                op.fases.forEach(f=>{
                  if(f.fase === faseSeleccionada){
                    this.datosTablaTratamientos = f.ptiActualSinEdicion;
                    this.datosTablaTratamientos = this.datosTablaTratamientos.map(objeto => {
                      return { ...objeto, rowspan: objeto.tratamientos.length * 3, filas: objeto.tratamientos.length - 1 };
                    });
                  }
                })
              } else {
                op.fases.forEach(f=>{
                  if(f.fase === faseSeleccionada){
                    this.datosTablaTratamientos = f.tratamientos;
                  }
                })
              }
            }
          });
          this.loaderSubtitulo = false;
        }, 1000);
    },
    async obtenerPtiActual() {
      this.datosTabla = [];
      this.loader = true;
      this.loaderSubtitulo = true;
      const params = {
        idPti: this.idPti,
        modoEdicion: this.modoEdicion,
        opcion: this.opcionAceptadaHistorial
      }
      this.$http.post(this.$api + 'pti/visible/obtener/tratamientos/ptiActual', params )
      .then(respuesta => {
            if (respuesta.data.data) {
              this.puedeEditar = respuesta.data.data[0].cobrado;
              respuesta.data.data.forEach(it => {
                this.datosTabla.push(it);
                if (it.opcionAceptada){
                  this.fases = it.fases;
                }
              })
            }

          }
      ).finally(() => {
            this.loader = false;
            this.obtenerFaseSeleccionada(1);
          }
      )
    },
    entrarModoEdicionPtiActual() {
      this.modoEdicion = true;
      this.obtenerPtiActual();
      this.obtenerEtapas();
      this.getCatalogoPadecimientos();
      this.getCatalogoTratamientos();
      this.getTipoDientePaciente();
      this.traerDoctores();
      this.$refs.ptiActual.entrarModoEdicion();
    },
    salirModoEdicionPtiActual() {
      if (!this.revisarSiExisteDatoEditable()) {
        this.abrirModal(1)
      } else {
        this.modoEdicion = false;
        this.$refs.ptiActual.salirModoEdicion();
        this.seleccionoSubtituloVersionPti(4);
      }
    },
    obtenerEstatusPti() {
      this.opcionesEstatus = [];
      this.$http.get(this.$api + 'catalogos/obtenerEstatusPtiTx').then(respuesta => {
            if (respuesta.data.data) {
              this.opcionesEstatus = respuesta.data.data;
            }
          }
      )
    },
    revisarSiExisteDatoEditable(){


      let aux = true;
      this.datosTablaTratamientos.forEach(tx=>{
        tx.tratamientos.forEach(t=>{
          if(t.cambiosTratamiento != null){
            if(t.editado || (t.cambiosTratamiento.length > 0 && t.cambiosTratamiento[0].idTratamiento != null)){
              aux = false;
            }
          }
        });
      });
      let i = this.listaTxModificados.findIndex(i => i.editado === true);
      if(i > -1) {
        aux = false;
      }
      let j = false;
      if(this.datosTablaNuevosTratamientos.length > 0){
        this.datosTablaNuevosTratamientos.forEach(nt => {
          nt.tratamientos.forEach(t => {
            if(t.idTratamiento != null && nt.idEtapa != null && nt.idPadecimiento != null && nt.idDiente != null && t.idEtapa != null){
              j = true;
            }else{
              j = false;
            }
          });
        });
        if(j){
          aux = false;
        }else{
          aux = true;
        }
      }
      
      return aux;
    },

    agregarTratamiento(){
      this.datosTablaNuevosTratamientos.push({
        etapa: "",
        idEtapa: 3,
        od: null,
        idDiente: null,
        padecimiento: "",
        idPadecimiento: null,
        tratamientos: [{
          cantidad: 1,
          estatusPago: "NO PAGADO",
          idEstatus: 2,
          idTratamiento: null,
          tratamiento: null,
          idEtapa: 3,
          etapa: null,
          precio: null,
          editarEtapaManual: false,
          fase: this.opcionPtiSeleccionadaSubtitulo,
        }]
      });
    },
    obtenerEtapas() {
      this.$http.get(
        this.$api + "padecimientotagetapa/obteneretapas"
      ).then((response) => {
        this.etapas = response.data.data
        this.etapasFiltro = this.etapas;
      })
    },
    getCatalogoPadecimientos() {
      this.loader = true;
      this.$http.get(this.$api + "catalogos/listaPadecimientos").then((response) => {
        if (Array.isArray(response.data.data) == true) {
          this.arrayPadecimiento = response.data.data.map((item) => {
            const data = {
              idPadecimento: item.idPadecimento,
              nombre: item.descripcion.toLowerCase(),
            };
            return data;
          });
          this.arrayPadecimientoFiltro = this.arrayPadecimiento;
        }
        this.loader = false;
      })
      .catch((error) => {
        console.error("Catalogo de Padecimientos: " + error);
      });
    },
    getCatalogoTratamientos() {
      this.arrayTratamiento = [];
      const params = {
        idClinica: this.$localStorageService.getIdClinica()
      }
      this.$http.post(this.$api + "replica/obtener/lista/tratamientos/porclinica", params )
      .then((response) => {
        if (Array.isArray(response.data.data) == true) {
          // this.arrayTratamiento = response.data.data;
          this.arrayTratamiento = response.data.data.map((item) => {
            const data = {
              idTratamiento: item.idTratamiento,
              nombre: item.nombre,
              precio: item.precio,
            };
            return data;
          });
          this.arrayTratamientoFiltro = this.arrayTratamiento;
        }
      })
      .catch((error) => {
        console.error("Catalogo de Tratamientos:" + error);
      });
    },
    getTipoDientePaciente() {
      const params = {
        idPaciente: this.idPaciente,
        idPti: this.idPti
      }
      this.$http
          .post(
              this.$api +
              "replica/obtener/tipo/diente/paciente", params     )
          .then((response) => {
            this.tipoDiente = response.data.data.denticion;
            this.getCatalogoDientes();
          })
          .catch((error) => {
            console.error("Tipo de Diente del Paciente:" + error);
          });
    },
    getCatalogoDientes() {
      this.arrayDiente = [];
      this.listaDientes = [];
      var url = "";
      if (this.tipoDiente === "2") {
        url = "catalogos/listaDientesAdulto/concero";
      } else if (this.tipoDiente === "1") {
        url = "catalogos/listaDientesInfantil/concero";
      } else if (this.tipoDiente === "3") {
        url = "catalogos/listaDientes/ordenados/concero";
      } else {
        this.tipoDiente = "3";
        url = "catalogos/listaDientes/ordenados/concero";
      }

      this.$http
          .get(this.$api + url)
          .then((response) => {
            if (Array.isArray(response.data.data) == true) {
              this.arrayDiente = response.data.data;
              this.arrayDiente.forEach(d => {
                if(d.numeroDiente == 0){
                  if(d.nombre == "BOCA COMPLETA"){
                    this.listaDientes.forEach(ld => {
                      if(ld==85){
                        this.listaDientes.push(d.numeroDiente+"-"+d.nombre)
                      }
                    });
                  }else{
                    this.listaDientes.push(d.numeroDiente+"-"+d.nombre)
                  }
                }else{
                  this.listaDientes.push(d.numeroDiente)
                }
              });
            }
          })
          .catch((error) => {
            console.error("Catalogo de Dientes: " + error);
          });
    },
  }
}
</script>

<style scoped>
.estilo-iconos{
  border-radius: 49%;
  background: #ffffff;
  border-color:  #1B81AF;
}
.boton-color:hover{background: yellow;}
.centrar-elementos{
  display: flex;
  align-items: center;
  justify-content: center;
}
.opciones-versionespti{
  margin: 0.5vw;
  border-radius: 10px;
  box-shadow: 0px 10px 10px -14px black;
}
.titulo-versionespti{
  text-align: start;
  font-size: .80rem;
}
.subtitulo-versionespti{
  font-size: .75rem;
}
.subtitulo-versionespti:hover {
  background-color: #f2f1f1;;
  font-weight: 700;
  padding: 5px;
}
.subtitulo-seleccionado{
  background-color: #f2f1f1;;
  font-weight: 700;
  padding: 5px;
}
.btn-outline-info:hover {
  background-color: #cccccc47;
}
.boton-switch-active {
  background-color: white;
  border-color: var(--color-background-disabled) !important;
  border-radius: 50px !important;
  box-shadow: 0px 0px 2px 0px rgba(0,0,0,0.50);
  padding-top: 10px !important;
  padding-bottom: 10px !important;
  padding-left: 30px !important;
  padding-right: 30px !important;
  color: var(--color-icono) !important;
  font-weight: bolder;
}
.boton-switch {
  background: none !important;
  border: none !important;
  padding-top: 10px !important;
  padding-bottom: 10px !important;
  padding-left: 30px !important;
  padding-right: 30px !important;
  color: var(--color-background-disabled);
}
.paddingbotones {
  padding-top: 5px;
  padding-bottom: 0px;
  padding-left: 7px;
  padding-right: 7px;
}
.contenedorTablaSinColor {
  padding: 8px;
  height: 88vh;
}

.swal2-styled {
  margin: 2.3125em !important;
}

.btn-outline-info.disabled, .btn-outline-info:disabled {
  color: #696969e3 !important;
  background-color: #908e8e1f;
  border-color: #737373;
}
.linea {
  border-top: 1px solid #1b81af;
  height: 2px;
  max-width: 85px;
  padding: 0;
  margin: auto;
}
.linea {
  border-top: 1px solid #1b81af;
  height: 2px;
  max-width: 85px;
  padding: 0;
  margin: auto;
}
</style>
